module.exports = __webpack_public_path__ + "static/media/07_plantilla_cuadrada_combo_simple_cf_stills_tetra_1l_cepita_manzana.04b1f6eb.png";